import api from './api'

export default {
  termalMap(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-in-map', { params })
  },

  pointMap(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-point-map', { params })
  },

  clinicTime(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-clinic-time', { params })
  },

  castrationsByClinic(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-clinic', { params })
  },

  castrationsAwaitingBatch() {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-awaiting-batch')
  },

  castrationsByBilling(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-billing', { params })
  },

  castrationsByMonth(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-month', { params })
  },

  castrationsByBreed(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-breed', { params })
  },

  castrationsByProtectors(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-protectors', { params })
  },

  castrationsByNGO(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-ngo', { params })
  },

  castrationsByCancelationReason(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-cancelation-reason', { params })
  },

  castrationsByRejectionReason(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-rejection-reason', { params })
  },

  castrationsTime(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-time-by-licensing', { params })
  },

  commentsByClinicsInApprovedCastrations(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/comments-by-clinics-in-approved-castrations', { params })
  },

  animalsInFair(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/animals-in-fair', { params })
  },

  monthlyAdoptionsByFair(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/monthly-adoptions-by-fair', { params })
  },

  adoptionsList(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/adoptions-list', { params })
  },

  adoptionsListFairs(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/adoptions-list/fairs', { params })
  },

  monthlyAdoptionsByFairManualAndDirect(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/monthly-adoptions-by-fair-manual-and-direct', { params })
  },

  adoptionsInFairs(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/adoptions-in-fairs', { params })
  },

  adoptionsByAgeGroup(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/adoptions-by-age-group', { params })
  },

  adoptionsByFamilyIncome(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/adoptions-by-family-income', { params })
  },

  adoptionsByRegion(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/adoptions-by-region', { params })
  },

  animalsInMap(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/animals/animals-in-map', { params })
  },

  animalsPointMap(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/animals/animals-point-map', { params })
  },

  clinicalCareItemClinicBalances(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/item-clinic-balances', { params })
  },

  clinicalCaresByMonth(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/by-month', { params })
  },

  clinicalCaresByYear(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/by-year', { params })
  },

  clinicalCaresByClinic(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/by-clinic', { params })
  },

  clinicalCaresByBreed(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/by-breed', { params })
  },

  clinicalCaresByUser(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/by-user', { params })
  },

  clinicalCaresByRegion(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/by-region', { params })
  },

  clinicalCaresByClassification(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/by-classification', { params })
  },

  clinicalCaresByPriority(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/by-priority', { params })
  },

  clinicalCaresInMap(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/in-map', { params })
  },

  clinicalCaresPointMap(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/clinical-cares/point-map', { params })
  },

  castrationsByUser(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-user', { params })
  },

  castrationsByYear(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-year', { params })
  },

  castrationsByCras(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-cras', { params })
  },

  castrationsByRegion(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-by-region', { params })
  },

  castrationsAnnualByClinicAndStatus(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-annual-by-clinic-and-status', { params })
  },

  castrationsRejectedAndCanceled(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-rejected-and-canceled', { params })
  },

  castrationsRegistry(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-registry', { params })
  },

  castrationsOperationalSummary(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/reports/castrations-operational-summary', { params })
  },
}
